import React, { Children } from "react";
import { SFGridItem, SFGridContainer } from "./index";
import SFSkeleton from "../skeleton";
import getStyled from "../../hooks/getStyled";
import PropTypes from "prop-types";

const { styled } = getStyled();

const ResponsiveGridContainer = styled(SFGridContainer, {
  shouldForwardProp: (prop) =>
    prop !== "minWidth" && prop !== "maxWidth" && prop !== "mobileWidth",
})(({ theme, minWidth, maxWidth, mobileWidth, spacing }) => ({
  alignItems: "stretch",
  // Spacing in the grid is added to the padding of each grid item
  // In order to make the grid items size the same as the values provided in the props,
  // we need to add the spacing to the width of the grid items
  "& > .MuiGrid-item": {
    width: "100%",
    minWidth: `calc(${minWidth} + ${spacing * parseInt(theme.spacing(1))}px)`,
    maxWidth: `calc(${maxWidth} + ${spacing * parseInt(theme.spacing(1))}px)`,
    ...(mobileWidth && {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        maxWidth: `calc(${mobileWidth} + ${
          spacing * parseInt(theme.spacing(1))
        }px)`,
      },
    }),
  },
}));

const SFResponsiveGrid = ({
  variant = "card",
  skeleton,
  count = 12,
  children,
}) => {
  const responsiveGridVariants = {
    card: {
      minWidth: "320px",
      maxWidth: "330px",
      mobileWidth: "410px",
      spacing: 2.5,
    },
  };

  if (skeleton) {
    return (
      <ResponsiveGridContainer
        minWidth={responsiveGridVariants[variant].minWidth}
        maxWidth={responsiveGridVariants[variant].maxWidth}
        mobileWidth={responsiveGridVariants[variant].mobileWidth}
        spacing={responsiveGridVariants[variant].spacing}
      >
        {[...Array(count)].map((_i, index) => (
          <SFGridItem key={index} xs={true}>
            <SFSkeleton />
          </SFGridItem>
        ))}
      </ResponsiveGridContainer>
    );
  }

  return (
    <ResponsiveGridContainer
      minWidth={responsiveGridVariants[variant].minWidth}
      maxWidth={responsiveGridVariants[variant].maxWidth}
      mobileWidth={responsiveGridVariants[variant].mobileWidth}
      spacing={responsiveGridVariants[variant].spacing}
    >
      {Children.map(children, (child) => (
        <SFGridItem xs={true}>{child}</SFGridItem>
      ))}
    </ResponsiveGridContainer>
  );
};

export default SFResponsiveGrid;

SFResponsiveGrid.propTypes = {
  // The variant of the responsive grid
  variant: PropTypes.oneOf(["card"]).isRequired,
  // The children of the component
  children: PropTypes.node.isRequired,
};
